import React from "react";

export const Logo = ({ className = "h-11 w-11", withText = true }) => {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <svg
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="50" cy="50" r="44" stroke="#0A2342" strokeWidth="6" fill="white" />
        <rect x="30" y="28" width="11" height="44" rx="2" fill="#C1121F" />
        <rect x="59" y="28" width="11" height="44" rx="2" fill="#0A2342" />
        <rect x="30" y="45" width="40" height="10" rx="2" fill="#0A2342" />
      </svg>
      {withText && (
        <span className="font-heading leading-tight">
          <span className="block text-brand-darkBlue font-extrabold text-base sm:text-lg tracking-tight">
            HYLTONS
          </span>
          <span className="block text-brand-red font-semibold text-[11px] sm:text-xs tracking-[0.18em] uppercase">
            Healthcare Solutions
          </span>
        </span>
      )}
    </div>
  );
};
